module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "row"
  }, _vm._l((_vm.menu), function(item) {
    return (item.visibleForAdmin || _vm.isSuperAdmin) ? _c('router-link', {
      key: item.key,
      staticClass: "menu-item",
      attrs: {
        "to": {
          name: item.uri
        }
      },
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "manage row"
  }, [_c('router-link', {
    staticClass: "ctn-profil",
    attrs: {
      "to": {
        name: 'Profile'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.picture,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/img/logo-patrim.svg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0647e982"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 616
// module chunks = 1